<template>
    <div class="p2p-ask">
        <b-card no-body class="box-ask-price mb-3">        
            <b-card-body>            
                <b-form autocomplete="off">
                    <b-form-group
                        :label="`Price (${ quoteSymbol })`"
                        label-for="price"
                        >
                        <b-form-input
                        id="price"
                        v-model="price"
                        type="number"
                        placeholder="Enter price"
                        required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        :label="`Amount (${ baseSymbol })`"
                        label-for="amount"
                        >
                        <b-form-input
                        id="deposit-amount"
                        v-model="amount"
                        type="number"
                        placeholder="Enter amount"
                        required
                        ></b-form-input>
                        <b-card-text class="text-right balance">
                            {{ (askData.orderId) ? utils.bigToCommon(askData.amount, baseDecimals) : parseFloat(amount) }} {{ baseSymbol }}&nbsp;<b-icon-arrow-right></b-icon-arrow-right>&nbsp;{{ (parseFloat(amount) * parseFloat(price)).toFixed(4) }} {{ quoteSymbol }}
                        </b-card-text>
                    </b-form-group>
                    <b-form-group size="sm">
                        <b-form-input v-model="amount" type="range" min="0" :max="maxAmount" size="sm"></b-form-input>
                        <b-card-text class="text-right avbl">
                            Avbl: {{ maxAmount }} {{ baseSymbol }}
                        </b-card-text>
                        <b-card-text class="text-right max-sell">
                            Max Sell: {{ (parseFloat(maxAmount) * parseFloat(price)).toFixed(4) }} {{ quoteSymbol }}
                        </b-card-text>
                        <b-card-text class="text-right est-fee">
                            Est. Fee: {{ (parseFloat(amount) * parseFloat(price)).toFixed(4) * 2 / 1000 }} {{ quoteSymbol }}
                        </b-card-text>
                    </b-form-group>
                </b-form>

                <div v-if="!loadingData">
                <b-btn class="btn-custom btn-cancel mr-3" @click="$emit('p2p-ask-cancel')">
                    Cancel
                </b-btn>

                <b-button
                    class="btn-custom btn-ask"
                    :disabled='isDisabled'
                    v-if="!loadingData"
                    @click="ask()"
                    >
                    Submit <b-spinner v-if="isDisabled" small label="Loading..."></b-spinner>
                </b-button>
                </div>
                <div v-else>
                    <b-skeleton type="button"></b-skeleton>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import { ethers } from 'ethers'
import { FT, FTMarket, FTMarketMulticall } from '@baza/sdk'

export default {
    name: 'P2PAsk',
    data: () => ({
        quote: '',
        quoteDecimals: 18,
        quoteSymbol: '',
        base: '',
        baseDecimals: 18,
        baseSymbol: '',
        marketAddress: '',
        lpOrderId: ethers.BigNumber.from(0),
        price: 0,
        amount: '0',
        maxAmount: 0,
        isBaseNative: false,
        isQuoteNative: false,
        isDisabled: false,
        isBaseApproved: false,
        market: {},
        loadingData: true
    }),
    props: ['askData', 'quoteLink', 'baseLink'],
    created: async function () {
        this.market = await FTMarket.setMarket(this.baseLink, this.quoteLink, this.provider)
        let calls = await FTMarketMulticall.setMulticall(this.market.baseToken, this.market.quoteToken, this.provider)

        this.marketAddress = this.market.marketAddress
        this.quote = this.market.quoteToken
        this.base = this.market.baseToken
        this.isQuoteNative = this.market.isQuoteNative
        this.isBaseNative = this.market.isBaseNative
        this.address = await this.provider.getSigner().getAddress()

        let { quoteDecimals, quoteSymbol } = await calls.getQuoteInfo()
        this.quoteDecimals = quoteDecimals
        this.quoteSymbol = quoteSymbol
        let { baseDecimals, baseSymbol } = await calls.getBaseInfo()
        this.baseDecimals = baseDecimals
        this.baseSymbol = baseSymbol

        let baseFT = new FT(this.base, this.provider)
        this.isBaseApproved = this.isBaseNative || !(await baseFT.allowance(this.address, this.marketAddress)).eq(0)
        this.maxAmount = ethers.utils.formatUnits(await baseFT.balanceOf(this.address), baseDecimals)
        this.amount = this.maxAmount

        if (this.askData.orderId) {
            this.price = ethers.utils.formatUnits(this.askData.price, this.quoteDecimals)
            this.lpOrderId = this.askData.orderId || ethers.BigNumber.from(0)
            this.amount = this.askData.amount.toNumber()
        }

        this.loadingData = false
    }, 
    methods: {
        async baseApprove() {
            let baseFT = new FT(this.base, this.provider)
            let tx = await baseFT.approve(this.marketAddress)
            this.$bvToast.show('tx-confirm')
            await tx.wait()
            this.$bvToast.show('tx-success')
            this.$bvToast.hide('tx-confirm')
            this.isBaseApproved = true
        },
        async ask () {
            try {
                this.isDisabled = true
                if (!this.isBaseApproved) {
                    await this.baseApprove()
                }
                let amount = ethers.utils.parseUnits(this.amount, this.baseDecimals)
                let price = ethers.utils.parseUnits(this.price, this.quoteDecimals)
                
                let tx = await this.market.ask(this.lpOrderId, amount, price)
                this.$bvToast.show('tx-confirm')
                await tx.wait()
                this.$emit('p2p-ask-success', {
                    txHash: tx.hash
                })
                this.$bvToast.show('tx-success')
                this.$bvToast.hide('tx-confirm')
            } catch (e) {
                this.$bvToast.hide('tx-confirm')
                this.$bvToast.show('tx-error')
                this.isDisabled = false
            }
        }
    }
};
</script>

<style lang="scss">
    .p2p-ask{        
        .base-name{
            font-size: 30px;
            font-weight: 700;
        }
        .box-ask-price{
            background-color: #F4F5F7;
            border-radius: 8px;
            border: none;
            label{
                color:#9D22C1;
                text-transform: uppercase;
                font-size: 12px;
            }
            #base-price{
                height: 56px;
                border-radius: 8px;
                border: 1px solid #DFE1E6;
            }
            .balance{
                font-size: 14px;
                color: #5E6C84;
                font-weight: normal;
                margin-top: 10px;
                justify-content: end;
            }
            .avbl{
                font-size: 14px;
                color: #5E6C84;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 0px;
                justify-content: end;
            }
            .max-sell{
                font-size: 14px;
                color: #5E6C84;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 0px;
                justify-content: end;
            }
            .est-fee{
                font-size: 14px;
                color: #5E6C84;
                font-weight: normal;
                margin-top: 0px;
                justify-content: end;
            }
            #deposit-amount,#price{
                height: 56px;
                border-radius: 8px;
                border: 1px solid #DFE1E6;
            }
        }
        .btn-custom{
            padding: 8px 16px;
            border: none;
            font-weight: 400;
            border-radius: 30px;
            &:focus{
                box-shadow: none;
            }         
        }
        .btn-ask{
            color: #fff;
            background-color: #DE350B;
            &:hover{
                background-color: #DE350B;
            }
            &.disabled,&:disabled{
                background-color: #DE350B;
            }      
        }
        .btn-cancel{
            color: #196EC2;
            background-color: rgba(25, 110, 194, 0.1);
            &:hover{
                background-color: rgba(25, 110, 194, 0.295);
                color: #196EC2;
            }
        }
    }
</style>
